import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, Icon, Stack, Type } from 'react-spark';
import stateSelectors from '../../redux/state-selectors';

class OffersCardRow extends Component {
    static propTypes = {
        icon: PropTypes.node,
        label: PropTypes.node,
    };

    render() {
        const { icon, label } = this.props;

        return (
            <Stack className="sprk-u-Flex--row sprk-o-Stack--center-row sprk-u-ptm sprk-u-pbs">
                <Stack.Item className="sprk-u-Color--purple-dark" style={{ width: 24, textAlign: 'center' }}>
                    {icon}
                </Stack.Item>
                <Stack.Item className='sprk-u-Display--flex sprk-o-Stack--center-column' style={{ flex: 1 }}>
                    <Type.BodyThree className='sprk-u-man sprk-u-plm' style={{ lineHeight: 1.4 }}>
                        {label}
                    </Type.BodyThree>
                </Stack.Item>
            </Stack>
        );
    }
}

class OffersV2ExpectationsCardComponent extends Component {
    static propTypes = {
        contentTop: PropTypes.node,
        termCounts: PropTypes.objectOf(PropTypes.number),
    };

    render() {
        const { contentTop, termCounts, ...props } = this.props;
        const terms = Object.keys(termCounts);

        return (
            <Card {...props}>
                {contentTop}

                {/* clock */}
                <OffersCardRow
                    icon={<Icon name="same-day" size="m" className="sprk-c-Icon--stroke-current-color" />}
                    label="Money in your account as soon as today" />

                {/* free */}
                <OffersCardRow
                    icon={<Icon name="free" size="m" className="sprk-c-Icon--stroke-current-color" />}
                    label="No early payoff penalties" />

                {/* lock */}
                <OffersCardRow
                    icon={<Icon name="lock" size="m" className="sprk-c-Icon--stroke-current-color" />}
                    label="Fixed rates through the life of your loan" />

                {/* calendar */}
                {terms.length > 1 && (
                    <OffersCardRow
                        icon={<Icon name="calendar" size="m" className="sprk-c-Icon--stroke-current-color" />}
                        label="Two terms to choose from – 36 or 60 months" />
                )}
            </Card>
        );
    }
}

export const OffersV2ExpectationsCard = connect(
    // State
    (state) => ({
        termCounts: stateSelectors.selectTermCounts(state),
    }),
    // Dispatch
    () => ({})
)(OffersV2ExpectationsCardComponent);
